var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "9273_group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "9275_vector",
    d: "M21.45 19.2129L15.8333 15.8796V8.32956C15.8333 7.66289 15.3 7.12956 14.6333 7.12956H14.5333C13.8667 7.12956 13.3333 7.66289 13.3333 8.32956V16.1962C13.3333 16.7796 13.6333 17.3296 14.15 17.6296L20.2333 21.2796C20.8 21.6129 21.5333 21.4462 21.8667 20.8796C22.2167 20.2962 22.0333 19.5462 21.45 19.2129ZM15 0.462891C6.71667 0.462891 0 7.17956 0 15.4629C0 23.7462 6.71667 30.4629 15 30.4629C23.2833 30.4629 30 23.7462 30 15.4629C30 7.17956 23.2833 0.462891 15 0.462891ZM15 27.1296C8.56667 27.1296 3.33333 21.8962 3.33333 15.4629C3.33333 9.02956 8.56667 3.79622 15 3.79622C21.4333 3.79622 26.6667 9.02956 26.6667 15.4629C26.6667 21.8962 21.4333 27.1296 15 27.1296Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockWhite);
export default __webpack_public_path__ + "static/media/Clock_white.a8eadae6bc0063a86bc204e055bb388f.svg";
export { ForwardRef as ReactComponent };